import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { NQHint } from "@visonum/network-quality-sdk";
import { map, mergeMap, take } from "rxjs";
import { getSdk } from "../../networkQuality";
import { AppThunk } from "../../store";
import * as R from "ramda";
import { logger } from "../../helper/logger";

export interface HintsState {
  hints: NQHint[],
}

const initialState: HintsState = {
  hints: [],
}

export const initHints = (): AppThunk => (dispatch, getState) => {
  const hintsObservable = getSdk().history().pipe(
    take(1),
    map(nqRecords => {
      const latestRecord = R.head(R.sort((a,b) => b.date.getTime() - a.date.getTime(), nqRecords));
      const speedtestId = latestRecord?.prepareResult.init.speedtest.id;
      return speedtestId
    }),
    mergeMap(speedtestId => getSdk().hints(speedtestId)),
  );

  hintsObservable.subscribe({
    next: (hints) => {dispatch(updateHints(hints))},
    error: (err) => logger.debug(err, `initHints failed with`), // TODO: report to sentry
  })

}; 

export const hintSlice = createSlice({
  name: 'hints',
  initialState,
  reducers: {
    updateHints: (state, action: PayloadAction<NQHint[]>) => {
      state.hints = action.payload
    },
  }
});

export const { updateHints } = hintSlice.actions;

export default hintSlice;